<div class="social-wall-widget animate__animated" [ngClass]="animation()" [style.animationDelay.ms]="animationDelay()">
  <lib-social-wall
    [channel]="channelId()"
    [defaultChannelId]="defaultChannelId()"
    [pageSize]="postCount()"
    [enableLoadMore]="false">
  </lib-social-wall>

  <button
    mat-flat-button
    class="button button--primary button--large social-wall-widget__see-all"
    data-cy="social-wall-widget-see-all"
    (click)="seeAllPosts.emit()">
    {{ 'SOCIAL_WALL.see_all_posts' | translate }}
  </button>
</div>
